import { useState } from "react";
import { useAuth } from "../app/AuthContext";
import { api } from "../lib/api";

export function SaveBrandButton({ brandId }: { brandId: string }) {
  const { user } = useAuth();
  const [saved, setSaved] = useState(false);
  const [pending, setPending] = useState(false);

  if (!user) {
    return <a href="/login"><button>Log in to save</button></a>;
  }

  const onClick = async () => {
    setPending(true);
    try {
      if (saved) { await api.brands.unsave(brandId); setSaved(false); }
      else       { await api.brands.save(brandId);   setSaved(true); }
    } finally {
      setPending(false);
    }
  };

  return (
    <button onClick={onClick} disabled={pending} className={saved ? "" : "primary"}>
      {saved ? "Saved ✓" : "Save brand"}
    </button>
  );
}
